export const required = (value, allValues, props, name) => {
  value =
    typeof value === "string" || value instanceof String ? value.trim() : value;
  return value || value === 0 ? undefined : `This field is required`;
};

export const email = value => {
  value =
    typeof value === "string" || value instanceof String ? value.trim() : value;
  return value && !/^\S+@\S+$/i.test(value)
    ? "Invalid email address"
    : undefined;
};

export const match = (value, allValues) => {
  return value === allValues.order.email ? undefined : `Emails must match`;
};
